<div class="avatarDialog">
  <sync-dialog 
  [config]="
  {
    title: 'Change profile picture', 
    isClosable: false, 
    actionButton: 'Save', 
    cancelButton: 'Cancel',
    isActionButtonDisabled: !avatarForm.valid || showAlert,
    onCancelClick: closeAvatarDialog,
    onActionClick: saveProfileChanges
  }"
  [open]="showAvatarDialog" 
  [isFullScreen]="false"
  [onClose]="closeAvatarDialog">
  <form [formGroup]="avatarForm" method="post" ngNativeValidate>
     <div class="card">
        <div class="alert-messages" *ngIf="showAlert">
         <app-error [errcode]="errcode"></app-error>
        </div>
        <div class="card-content">
           <div class="content-container">
              <div class="profile-picture">
                 <sync-avatar [size]="96" [url]="'data:image/png;base64,' + logo" [initials]="user.display_name | b64"></sync-avatar>
              </div>
              <div class="button-container">
                 <sync-button
                 [type]="'outlined'"
                 [label]="'Upload new'"
                 [size]="'large'"
                 [leadAdornment]="true"
                 [leadIconAdornment]="'upload'"
                 [onClick]="openDialog"
                 ></sync-button>
                 <input
                 #dialogDisplayAvatar
                 type="file"
                 style="display: none"
                 formControlName="logo"
                 accept="image/*"
                 (change)="uploadFile($event)"
                 />
                 <sync-button
                 [type]="'flat'"
                 [label]="'Remove'"
                 [size]="'large'"
                 [onClick]="clearAvatar"
                 ></sync-button>
              </div>
           </div>
        </div>
     </div>
  </form>
  </sync-dialog>
</div>